import React, { Component } from 'react';
import { NotFound } from '../components/NotFound/NotFound';

export class NotFoundPage extends Component {
  render() {
    return (
      <div style={{ height: '100vh' }}>
        <NotFound />
      </div>
    );
  }
}
